import { gql } from '@apollo/client';

const INITIALIZE_RESOURCE_DOWNLOAD = gql`
  mutation InitializeResourceDownlo($resourceId: ID!, $versionId: Int!) {
    initResourceDownload(resourceId: $resourceId, versionId: $versionId)
  }
`;

export default INITIALIZE_RESOURCE_DOWNLOAD;
